import PropTypes from "prop-types"

export const VALUE = PropTypes.oneOfType([PropTypes.string, PropTypes.number])
